module.exports = __webpack_public_path__ + "assets/img/huawei.9ce6cd54.png";